/**
 * Deployment-environment detection for the PharmaPOS Mall.
 *
 * The demo mall (mall.demo.pharmapos.com) is served from the SAME build as
 * production, so the label is decided at runtime — no separate demo build.
 * The product name comes from /site-config.js (per deployment + per domain),
 * so mall.ppos.my shows "PPOS Mall" and mall.pharmapos.com "PharmaPOS Mall".
 */
import { siteBrand } from './site-config.js';

export const IS_DEMO = location.hostname.split('.').includes('demo');

/** " (DEMO)" on demo hosts, empty on production. */
export const DEMO_SUFFIX = IS_DEMO ? ' (DEMO)' : '';

/** Mall app name for the tab title and banner. */
export const APP_DISPLAY_NAME = `${siteBrand()} Mall${DEMO_SUFFIX}`;
